var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { forwardRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { Spinner } from '../Spinner';
import { InferiorContent } from '../TextInput/InferiorContent';
import { SuperiorContent } from '../TextInput/SuperiorContent';
import { Flex } from '../Flex';
import { useUniqueId } from '../../hooks';
import * as S from './styles';
import { runTextareaValidations, getQuantTyped, validation } from './utils';
/**
 * Componente TextArea do Design System OLX
 *
 * É um componente de formulário que adiciona um estilo ao textarea nativo do HTML.
 *
 * **Importante**: O atributo 'aria-label' é obrigatório quando um label não for informado, para que o componente fique acessível a leitores de tela.
 *
 * Veja mais na página de {@link http://localhost:6006/?path=/story/components-form-textarea documentação do componente}.
 */
export const TextArea = forwardRef((props, ref) => {
  var _a;
  const {
      'aria-label': ariaLabel,
      className,
      display,
      id,
      margin,
      marginBottom,
      marginLeft,
      marginRight,
      marginTop,
      state,
      stateMessage,
      width,
      height,
      limitTextSize
    } = props,
    rest = __rest(props, ['aria-label', "className", "display", "id", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "state", "stateMessage", "width", "height", "limitTextSize"]);
  const errorId = "textarea-error-".concat(Math.floor(Math.random() * 101));
  runTextareaValidations(props);
  const hasLimitText = validation(limitTextSize);
  const limitTextID = useUniqueId('ds-textarea-limittext');
  return React.createElement(S.ComponentWrapper, {
    "data-ds-component": "DS-TextArea",
    display: display,
    margin: margin,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    width: width,
    className: className
  }, React.createElement(SuperiorContent, Object.assign({}, props, {
    id: id,
    size: "medium"
  })), React.createElement(S.TextAreaContainer, {
    state: state,
    disabled: props.disabled === true,
    hasContent: props.value !== undefined && props.value !== ''
  }, React.createElement(S.TextAreaField, Object.assign({
    id: id,
    "aria-busy": state === 'loading',
    "aria-label": ariaLabel,
    "aria-invalid": state === 'error',
    "aria-errormessage": state === 'error' ? errorId : '',
    "aria-disabled": props.disabled === true
  }, hasLimitText && {
    'aria-describedby': limitTextID
  }, {
    height: height,
    ref: ref,
    maxLength: hasLimitText
  }, rest)), state === 'loading' && React.createElement(S.IconWrapper, null, React.createElement(Spinner, {
    "aria-label": (_a = props.stateMessage) !== null && _a !== void 0 ? _a : '',
    size: "extra-small"
  }))), React.createElement(Flex, {
    flexDirection: "row",
    justifyContent: rest.caption || state === 'error' ? 'space-between' : 'flex-end'
  }, React.createElement(InferiorContent, {
    errorId: errorId,
    state: state,
    stateMessage: stateMessage,
    disabled: props.disabled,
    caption: props.caption
  }), hasLimitText && React.createElement(S.LimitText, {
    id: limitTextID,
    "aria-label": "".concat(getQuantTyped(rest.value), " de ").concat(limitTextSize, " caracteres usado")
  }, getQuantTyped(rest.value), "/", limitTextSize)));
});
TextArea.displayName = 'TextArea';